<template>
  <div>
    
    <Header
      :mySellCarts="mySellCart" 
      :myPurchaseCarts="myPurchaseCart" 
      :menuAuthenticateds="menuAuthenticated"
      :site-datas="siteData"
    ></Header>
    <div style="min-height:600px; width:100%; display:block; margin:0; padding:0;"  :style="'min-height:'+$minHeight+';'">
        
        <loading :active='isLoading' :is-full-page='fullPage' :loader='loader'/>
        <router-view
          v-on:updateMySellCart="updateSellCartBox($event)" 
          v-on:updatePurchaseCartBox="updatePurchaseCartBox($event)" 
          v-on:updateLoginStatus="updateLoginStatus($event)"
          :site-datas="siteData"
        ></router-view>

    </div>
    

    
    <Footer
      :site-datas="siteData"
    ></Footer>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import Header from './pages/layout/Header';
import Footer from './pages/layout/Footer';
import mixin from "./mixin";

export default {
  name: 'App',
  components: {
    Loading, 
    Header, 
    Footer
  },
  mixins: [mixin],
  data() {
    return {
      isLoading: false,
      fullPage: true,
      loader: 'bars',
      isLogin: false,
      mySellCart: 0,
      myPurchaseCart: 0,
      menuAuthenticated: false,
      siteData: {}
    };
  },
  mounted(){
        var pageHeight=window.innerHeight-190;
        this.$minHeight=pageHeight+"px";
  },
  created() {
    if(this.$router.currentRoute.path == '/login' || this.$router.currentRoute.path == '/signup'){
      if(localStorage.getItem('_token')) {
        this.$router.push('/')
      }
      this.isLogin = true
    }
    const self = this
    this.onInactive(1800000, function() {
      self.$swal.fire ({
        icon: 'error',
        text: 'You have been logged out for 30 minutes of inactivity!'
      });
      localStorage.clear()
      self.$router.push("/login")
    });
    this.getSiteData();
  },
  methods: {
    updateSellCartBox: function(mySellCart) {
        this.mySellCart = mySellCart;
    },
    updatePurchaseCartBox: function(myPurchaseCart) {
        this.myPurchaseCart = myPurchaseCart;
    },
    updateLoginStatus: function(mySellCart) {
        this.menuAuthenticated = mySellCart;
    },
    onInactive: function(ms, cb) {
      var wait = setTimeout(cb, ms);
      document.onmousemove = document.mousedown = document.mouseup = document.onkeydown = document.onkeyup = document.focus = function() {
        clearTimeout(wait);
        wait = setTimeout(cb, ms);
      };
    },
    getSiteData: function() {
      this.isLoading = true;
      this.getSiteCMS().then(response => {
        this.siteData = response;
        this.isLoading = false;
      }).catch(error => {
        console.log(error);
        this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          text: "Can't fetch site CMS data!"
        });
      });
    },
  },
  watch: {
    '$route'(newPath) {
      if(newPath.path == '/login' || this.$router.currentRoute.path == '/signup') {
        this.isLogin = true
      }
      else {
        this.isLogin = false
      }
    }
  }
}
</script>

<style>
  @import "assets/css/vue-loading.scss";
  @import "assets/css/all.min.css";
  @import "assets/css/bootstrap.min.css";
  @import "assets/css/main.css";
  @import "assets/css/style.css";
  @import "assets/css/blog-2.css";
  @import "assets/css/faq.css";
  @import "assets/css/buy-in-bulk-page.css";
  @import "assets/css/custom-quote-page.css";
  @import "assets/css/sell-in-bulk-page.css";
  @import "assets/css/login.css";
  @import "assets/css/sell-your-device-main.css";
  @import "assets/css/cart.css";
  @import "assets/css/sell-your-device-cart.css";
  @import "assets/css/customer-info.css";
  @import "assets/css/terms.css";
  @import "assets/css/checkout-complete.css";
  @import "assets/css/blog-details.css";
  @import "assets/css/dashboard.css";
  @import "assets/css/purchase-order-all.css";
  @import "assets/css/sell-order-all.css";
  @import "assets/css/profile.css";
  @import "assets/css/purchase-order-paid.css";
  @import "assets/css/purchase-order-in-progress.css";
  @import "assets/css/reset-password.css";
  @import "assets/css/order-detail.css";
</style>
